export default function (name, _ = window.location.href) {
    return getUrlParameter(name)
}

export function getUrlParameter(paramName) {

    const urlParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();
    for (const [name, value] of urlParams) {
        newParams.append(name.toLowerCase(), value);
    }
    return newParams.get(paramName.toLowerCase());
}

export function getUrlParameterAs(paramName) {
    return JSON.parse(JSON.stringify(getUrlParameter(paramName)));
}

export function getUrlParameterAll(paramNam) {
    const urlParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();
    for (const [name, value] of urlParams) {
        newParams.append(name.toLowerCase(), value);
    }
    return newParams.getAll(paramName.toLowerCase());
}

export function hasUrlParameter(paramName) {
    const urlParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();
    for (const [name, value] of urlParams) {
        newParams.append(name.toLowerCase(), value);
    }
    return newParams.has(paramName.toLowerCase());
}
